import { render, staticRenderFns } from "./mould.vue?vue&type=template&id=154d5346&"
import script from "./mould.vue?vue&type=script&lang=js&"
export * from "./mould.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports